export default __webpack_public_path__ + "static/media/13.5cc3b90b.png";